import React from "react";
import { ModelListIcon } from "@components/common/model-list-icon";
export const ReportTypeHeader = ({ reportType }) => {
    var _a;
    if (!((_a = reportType.modelLabels) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return React.createElement(ModelListIcon, { modelLabels: reportType.modelLabels });
};
export default ReportTypeHeader;
